function isElementInEventPath(element, e) {
    // filter out null elements
    var elements = Array.isArray(element) ? element : [element];
    elements = elements.filter(function (i) { return i; });
    // iterate over event path to check if any of the elements is in there
    var path = e.composedPath();
    return !!path.find(function (pathElement) {
        return elements.find(function (testElement) { return pathElement.isSameNode && pathElement.isSameNode(testElement); });
    });
}
export default isElementInEventPath;
